import { CampaignModule } from '@almbrand/campaignmodule';
import { mapCtaProps } from 'common/buttonUtils';

export interface CampaignModuleComponentProps {
	id?: string | number;
	className?: string;
	image: Image;
	content: string;
	ctaGroupConfiguration: {
		ctaGroup: {
			items: CtaProps[];
		};
	};
	children?: React.ReactNode;
	opacityLayer?: boolean;
	followContentHeight?: boolean;
}

export const CampaignModuleComponent: React.FC<CampaignModuleComponentProps> = ({
	id,
	className,
	image,
	content,
	ctaGroupConfiguration: { ctaGroup },
	children,
	opacityLayer,
	followContentHeight,
}) => {
	const { imageFocalPoint, altText: imageAltText } = image.properties ?? {};

	return (
		<CampaignModule
			id={id}
			className={className}
			image={{
				imageSrc: image?.url,
				altText: imageAltText,
				objectPosition: imageFocalPoint ? `${imageFocalPoint?.x} ${imageFocalPoint?.y}` : undefined,
			}}
			content={content}
			ctaGroupProps={mapCtaProps(ctaGroup.items)}
			opacityLayer={opacityLayer}
			followContentHeight={followContentHeight}
		>
			{children}
		</CampaignModule>
	);
};
